export async function setPoster(video: HTMLVideoElement): Promise<string> {
    return new Promise((resolve, reject) => {
        let fakeVideo = document.createElement("video") as HTMLVideoElement;
        fakeVideo.setAttribute("playsinline", "true");

        function frameHandler() {
            try {
                const canvas = document.createElement("canvas") as HTMLCanvasElement;
                canvas.width = fakeVideo.videoWidth;
                canvas.height = fakeVideo.videoHeight;

                const context = canvas.getContext("2d");
                context.drawImage(fakeVideo, 0, 0, canvas.width, canvas.height);
                const poster = canvas.toDataURL();
                fakeVideo.pause();
                fakeVideo.removeEventListener("playing", frameHandler);
                fakeVideo.remove();
                fakeVideo = undefined;
                resolve(poster);
            } catch (error) {
                reject(error);
            }
        }

        fakeVideo.muted = true;
        fakeVideo.crossOrigin = "Anonymous";
        fakeVideo.addEventListener("playing", frameHandler);
        fakeVideo.src = video.src;
        fakeVideo.play();
    });
}
